import { render } from "./FinalSection.vue?vue&type=template&id=f08d6634&scoped=true"
import script from "./FinalSection.vue?vue&type=script&lang=js"
export * from "./FinalSection.vue?vue&type=script&lang=js"

import "./FinalSection.vue?vue&type=style&index=0&id=f08d6634&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08d6634"]])

export default __exports__